import Model from '~/models/Model';

export default class ApplicantDocument extends Model {
  resource() {
    return 'v1/applicant-documents';
  }
}
